import { Component, OnInit, Input } from '@angular/core';
import { images } from 'src/app/_service/data';

@Component({
  selector: "app-media",
  templateUrl: "./media.component.html",
  styleUrls: ["./media.component.scss"]
})
export class MediaComponent implements OnInit {
  childimage= images;
  constructor() {}

  ngOnInit() {}
}
